import React from "react";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import InquiryForm from "../components/InquiryForm";

import { Helmet } from "react-helmet-async";

const ContactPage = () => {
  return (
    <main data-testid="contact-page" className="bg-cream">
      <Helmet>
        <title>Contact Gralon Global — Request Export Quotes & Samples</title>
        <meta name="description" content="Contact Gralon Global's export team for premium botanical quotes, specification sheets, and samples. Based in Udaipur, India, serving global markets." />
      </Helmet>
      <section className="border-b border-line">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-24 pb-20">
          <div className="label-eyebrow">Contact</div>
          <h1 className="font-serif font-light mt-6 text-5xl lg:text-7xl leading-[1.02] text-ink max-w-4xl">
            We respond within<br />
            <span className="italic text-forest">one business day.</span>
          </h1>
          <p className="mt-8 max-w-2xl text-ink/75 text-lg leading-relaxed">
            Whether you need samples, price quotations or a custom specification —
            our export team is ready to assist. Send us a note and we'll be in touch.
          </p>
        </div>
      </section>

      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-16">
          {/* Contact info */}
          <div className="lg:col-span-4">
            <div className="space-y-10">
              <div>
                <div className="label-eyebrow">Email</div>
                <a
                  href="mailto:info@gralonglobal.com"
                  data-testid="contact-email"
                  className="mt-3 block font-serif text-2xl text-ink hover:text-forest"
                >
                  info@gralonglobal.com
                </a>
              </div>
              <div>
                <div className="label-eyebrow">Phone / WhatsApp</div>
                <a
                  href="tel:+917737671164"
                  data-testid="contact-phone"
                  className="mt-3 block font-serif text-2xl text-ink hover:text-forest"
                >
                  +91 77376 71164
                </a>
              </div>
              <div>
                <div className="label-eyebrow">Office</div>
                <p className="mt-3 font-serif text-xl text-ink leading-relaxed" data-testid="contact-address">
                  13/2 Vinayak Nagar,<br />
                  Bohra Ganesh Ji Road,<br />
                  Udaipur — Rajasthan, India
                </p>
              </div>
              <div>
                <div className="label-eyebrow">Business Hours</div>
                <p className="mt-3 font-serif text-xl text-ink leading-relaxed">
                  Mon – Sat &nbsp;·&nbsp; 09:30 – 18:30 IST
                </p>
              </div>

              <div className="pt-6 border-t border-line">
                <div className="text-sm text-muted leading-relaxed">
                  Prefer email? Send specifications, target volume and shipping
                  destination to{" "}
                  <a href="mailto:info@gralonglobal.com" className="text-forest underline">
                    info@gralonglobal.com
                  </a>
                  .
                </div>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="lg:col-span-8">
            <div className="bg-cream-alt p-8 lg:p-12 border border-line">
              <div className="label-eyebrow">Send an Inquiry</div>
              <h2 className="font-serif font-light mt-3 text-3xl lg:text-4xl text-ink mb-10">
                Tell us what you're sourcing.
              </h2>
              <InquiryForm />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContactPage;
